/**
 * Decides whether a PathSelector input is in a valid ("not an error") state.
 *
 * Empty input is neutral — the user has not yet typed anything, so there is
 * nothing to fail to match. An error is only shown when the user (or a saved
 * layout's `initialInputValue`) has supplied text that fails to resolve.
 */
export function isPathInputValid(
  inputValue: string,
  matchCount: number,
): boolean {
  return inputValue.length === 0 || matchCount > 0;
}
